<div class="skeleton">
  <div class="skeleton__tabs">
    @for (tab of numberOfTabs; track index; let index = $index) {
      <div class="skeleton__tabs--tab"></div>
    }
  </div>
  <div class="skeleton__content">
    <app-utils-action-buttons-skeleton></app-utils-action-buttons-skeleton>
    <app-utils-table-skeleton></app-utils-table-skeleton>
  </div>
</div>
